import { db } from '../firebase';
import { getCachedDoc } from './docCache';

// One shared, cached read of the site logo doc so App, Navbar, Footer and
// BrandBadge don't each fetch public/data/site_settings/logo independently on every
// load. docCache dedupes concurrent mounts into a single Firestore read, and its
// 30-min localStorage TTL means full page reloads within that window cost 0 reads
// (the logo effectively never changes). A logo change can lag up to 30 minutes.
const LOGO_TTL = 30 * 60 * 1000;

export function getSiteLogo() {
    if (!db) return Promise.resolve(null);
    return getCachedDoc('public/data/site_settings/logo', LOGO_TTL)
        .then(data => (data && data.logoUrl) ? data.logoUrl : null)
        .catch(e => { console.error('Error fetching logo:', e); return null; });
}
